import api from '@/api_alv'
import Vue from 'vue'
import i18n from '@/assets/i18n/i18n'
import { router } from '@/router.js'
// import gettersMainStore from '@/store/getters.js'

const DIR = 'erp/pricelists'
const DEFAULT_PRICELISTS = {
    "id": 0,
    "alvId": "ALV000000000PL",
    "description": null,
    "rows": [],
    "title": null,
}

const DEFAULT_PRICELISTSROWS = {
    "id": 0,
    "alvId": "ALV000000000PR",
    // PT refactor: not nice, should use getter instead of direct access to localStorage
    // "currency": gettersMainStore.getSelectedCurrency({ 'state.isLoggedIn':true }),
    "currency": null, // does not work on login: JSON.parse(localStorage.getItem('userData'))['user']['currency'],
    "distributor": null,
    "msp": null,
    "ppd": null,
    "priceCategory": 'highprice',
    "regions": null,
    "sps": null,
    "srp": null,
}

const state = {
    pricelists: [],
    selectedPricelists: [],
    isAllSelectedPricelists: false,

    // Filters & Actions & Buttons
    pricelistsSearch: '',
    selectedPricelistsAction: [],

    // Details
    defaultNewPricelists: DEFAULT_PRICELISTS,
    pricelistsUniqueId: '',
    expandedPricelists: [],
    pricelistsDetails: DEFAULT_PRICELISTS,

    // Edit Form
    selectedPricelistsId: null,

    // Panel: Pricelists rows
    pricelistsPricelistsRows: [],
    selectedPricelistsPricelistsRows: [],

    // Editing Dialog: pricelistsRows
    defaultPricelistsPricelistsRows:                DEFAULT_PRICELISTSROWS,
    pricelistsPricelistsRowsEditingDialogDetails:   DEFAULT_PRICELISTSROWS,
    pricelistsPricelistsRowsDistributorOptions:     [],
    pricelistsPricelistsRowsDistributorSearch:      null,
    pricelistsPricelistsRowsIsNewSearch:            null,

}

const getters = {
    // Pricelists List Page
    getPricelists                                   (state) { return state.pricelists },
    getSelectedPricelists                           (state) { return state.selectedPricelists },
    getIsAllSelectedPricelists                      (state) { return state.isAllSelectedPricelists },
    
    // Filters & Actions & Buttons
    getPricelistsSearch                             (state) { return state.pricelistsSearch },
    getSelectedPricelistsAction                     (state) { return state.selectedPricelistsAction },
    
    // Details
    getDefaultNewPricelists                         (state) { return state.defaultNewPricelists },
    getExpandedPricelists                           (state) { return state.expandedPricelists },
    getPricelistsDetails                            (state) { return state.pricelistsDetails },
    getPricelistsDetailsAlvId                       (state) { return state.pricelistsDetails.alvId },
    getPricelistsDetailsTitle                       (state) { return state.pricelistsDetails.title },
    getPricelistsDetailsDescription                 (state) { return state.pricelistsDetails.description },
    getPricelistsDetailsDistributor                 (state) { return state.pricelistsDetails.distributor },

    // Panel: Pricelists rows
    getPricelistsPricelistsRows                     (state) { return state.pricelistsPricelistsRows },
    getSelectedPricelistsPricelistsRows             (state) { return state.selectedPricelistsPricelistsRows },

    // Editing Dialog: pricelistsRows
    getDefaultPricelistsPricelistsRows              (state) { return state.defaultPricelistsPricelistsRows },
    getPricelistsPricelistsRowsEditingDialogDetails (state) { return state.pricelistsPricelistsRowsEditingDialogDetails },
    getPricelistsPricelistsRowsDistributorOptions   (state) { return state.pricelistsPricelistsRowsDistributorOptions },
    
    getPricelistsPricelistsRowsDetailsMsp           (state) { return state.pricelistsPricelistsRowsEditingDialogDetails.msp },
    getPricelistsPricelistsRowsDetailsPpd           (state) { return state.pricelistsPricelistsRowsEditingDialogDetails.ppd },
    getPricelistsPricelistsRowsDetailsSrp           (state) { return state.pricelistsPricelistsRowsEditingDialogDetails.srp },
    getPricelistsPricelistsRowsDetailsSps           (state) { return state.pricelistsPricelistsRowsEditingDialogDetails.sps },
    getPricelistsPricelistsRowsDetailsPriceCategory (state) { return state.pricelistsPricelistsRowsEditingDialogDetails.priceCategory },
    getPricelistsPricelistsRowsDetailsCurrency      (state) { return state.pricelistsPricelistsRowsEditingDialogDetails.currency },
    getPricelistsPricelistsRowsDetailsRegions       (state) { return state.pricelistsPricelistsRowsEditingDialogDetails.regions },
    getPricelistsPricelistsRowsDetailsDistributor   (state) { return state.pricelistsPricelistsRowsEditingDialogDetails.distributor },
    
    getPricelistsPricelistsRowsIsNewSearch          (state) { return state.pricelistsPricelistsRowsIsNewSearch },

}

const mutations = {
    // Pricelists List Page    
    setPricelists:                              (state, item)   => { state.pricelists = item },
    setSelectedPricelists:                      (state, item)   => { state.selectedPricelists = item },
    setIsAllSelectedPricelists:                 (state, item)   => { state.isAllSelectedPricelists = item },
    setPricelistsSearch:                        (state, item)   => { state.pricelistsSearch = item },
    
    // Filters & Actions & Buttons
    setSelectedPricelistsAction:                (state, item)   => { state.selectedPricelistsAction = item }, 
    
    // Details
    setDefaultNewPricelists:                    (state)         => { state.defaultNewPricelists = DEFAULT_PRICELISTS },
    setPricelistsUniqueId:                      (state, item)   => { state.pricelistsUniqueId = item },
    setExpandedPricelists:                      (state, item)   => { 
                                                                        if (Object.keys(item).length === 0) state.expandedPricelists = []
                                                                        else state.expandedPricelists.push(item) 
                                                                    },
    setPricelistsDetails:                       (state, item)   => { state.pricelistsDetails = item },
    setPricelistsDetailsAlvId:                  (state, item)   => { state.pricelistsDetails.alvId = item },
    setPricelistsDetailsTitle:                  (state, item)   => { state.pricelistsDetails.title = item },
    setPricelistsDetailsDescription:            (state, item)   => { state.pricelistsDetails.description = item },
    setPricelistsDetailsDistributor:            (state, item)   => { state.pricelistsDetails.distributor = item },

    // Panels
    setPricelistsPricelistsRows:                    (state, item)   => { state.pricelistsPricelistsRows = item },
    setSelectedPricelistsPricelistsRows:            (state, item)   => { state.selectedPricelistsPricelistsRows = item },

    // Editing Dialog: Pricelists rows
    setDefaultPricelistsPricelistsRows:             (state)         => { state.defaultPricelistsPricelistsRows = DEFAULT_PRICELISTSROWS },
    setPricelistsPricelistsRowsEditingDialogDetails:(state, item)   => { state.pricelistsPricelistsRowsEditingDialogDetails = item },
    setPricelistsPricelistsRowsDistributorOptions:  (state, item)   => { state.pricelistsPricelistsRowsDistributorOptions = item },
    
    setPricelistsPricelistsRowsDetailsMsp:          (state, item)   => { state.pricelistsPricelistsRowsEditingDialogDetails.msp = item },
    setPricelistsPricelistsRowsDetailsPpd:          (state, item)   => { state.pricelistsPricelistsRowsEditingDialogDetails.ppd = item },
    setPricelistsPricelistsRowsDetailsSrp:          (state, item)   => { state.pricelistsPricelistsRowsEditingDialogDetails.srp = item },
    setPricelistsPricelistsRowsDetailsSps:          (state, item)   => { state.pricelistsPricelistsRowsEditingDialogDetails.sps = item },
    setPricelistsPricelistsRowsDetailsPriceCategory:(state, item)   => { state.pricelistsPricelistsRowsEditingDialogDetails.priceCategory = item },
    setPricelistsPricelistsRowsDetailsCurrency:     (state, item)   => { state.pricelistsPricelistsRowsEditingDialogDetails.currency = item },
    setPricelistsPricelistsRowsDetailsRegions:      (state, item)   => { state.pricelistsPricelistsRowsEditingDialogDetails.regions = item },
    setPricelistsPricelistsRowsDetailsDistributor:  (state, item)   => { state.pricelistsPricelistsRowsEditingDialogDetails.distributor = item },

    setPricelistsPricelistsRowsIsNewSearch:         (state, item)   => { state.pricelistsPricelistsRowsIsNewSearch = item },

}

const actions = {
    async fetchPricelists({ commit, getters }) {

        commit('setIsLoading', true)
        
        // check for set filters
        let filterObj = {
            'search' :  getters.getPricelistsSearch,
        }

        // create string of filter params for api call
        let paramsString = this._vm.$alvPlugin.createApiUrlFilterString(filterObj)

        // Get list items from db
        let response = await api.getListData(DIR, getters.getCurrentPage, paramsString)   
        
        if(response === undefined || response.list.length === 0 || response.error === 1) { 
            commit('setNoDataText', 'lang_GENERAL_MESSAGE_NO_RECORDS_FOUND')
            commit('setPricelists', [])   
        } else {
            commit('setPricelists', response.list)   
        }

        this._vm.$alvPlugin.storePagingInformations(response.filteredRecords, response.currentPage, response.totalRecords)
        commit('setIsLoading', false)

    },
    // Fetch Details for a specific pricelist     
    async fetchPricelistsDetails({ commit, getters, dispatch }, alvId) {
        let values

        if(alvId === 'new') {
            values = JSON.parse(JSON.stringify(getters.getDefaultNewPricelists)) 
        }
        else {
            let response = await api.getDetailsById(DIR, alvId) 
            if(response === undefined || response.length === 0 || response.error === 1) {
                values = {}
            } else {
                values = response
            }
        }
        
        commit('setPricelistsDetails', values)
        dispatch('fetchPricelistsRows')
        commit('setIsLoading', false)
    },

    // SAVE
    async savePricelistsForm({ commit, getters, dispatch }) {
        let alvId = getters.getPricelistsDetailsAlvId
        let metaData = getters.getPricelistsDetails
        let isNew = router.currentRoute.params.alvId === "new"

        let response = await api.saveEditForm(DIR, alvId, metaData, isNew)

        if(response === undefined || response.length === 0 || response.error === 1) { 
            response = []
            commit('setSnackbar', { 
                type: 'error', 
                msg: i18n.t('lang_GENERIC_SNACKBAR_SAVING_NOT_SUCCESSFUL'), // TODO: better message for user
            })
        } else {
            commit('setSnackbar', { 
                type: 'success', 
                msg: i18n.t('lang_GENERIC_SNACKBAR_SAVING_SUCCESSFUL')
            })
            // redirect for url now with ALVID
            if(isNew) {
                router.push( { name: 'PricelistsEdit', params: { alvId:  response.response.alvId } })
            }
            // refresh data
            await dispatch('fetchPricelistsDetails',  response.response.alvId)
        }
    }, 

    // PRICELISTS DISTRIBUTOR (dropdown)
    async fetchDropdownPricelistsDistributor({ commit }, type) {
        let response = await api.getAzByType(type)
        commit('setPricelistsPricelistsRowsDistributorOptions', response.list)
    },

    // ACTIONS
    async doPricelistsAction({ commit, dispatch }) {
        if(state.selectedPricelists.length > 0) {
            switch(state.selectedPricelistsAction) {
                case 'delete':
                    commit('setShowDeletionDialog', true)
                    break
                case 'copy':
                    dispatch('copyPricelists')
                    break
            }
        } else {
            commit('setSelectionRequiredText', 'lang_GENERAL_SELECTION_REQUIRED_DIALOG_TEXT_AT_LEAST_ONE') 
            commit('setShowSelectionRequiredDialog', true)	
        }        
    },

    // Delete Pricelist
    async deleteSelectedPricelists({ commit, getters, dispatch }) {  
        const response = await api.deleteEntries(DIR, getters.getSelectedPricelists)
        if(response.error === -1) {        
            for(let i = 0; i < getters.getSelectedPricelists.length; i++) {
                let index = getters.getPricelists.findIndex(pricelists => pricelists.alvId == getters.getSelectedPricelists[i])
                Vue.delete(getters.getPricelists, index)
            }
            commit('setSelectedPricelists', [])
            commit('setSelectedPricelistsAction', [])
            dispatch('fetchPricelists')
        }
    },

    // COPY Pricelists
    async copyPricelists({ commit, getters, dispatch}) {
        let queryParams = { "action": "copy" }
        let metaData = { "alvIds": getters.getSelectedPricelists }

        let response = await api.triggerAction(DIR, metaData, queryParams)
        
        if(response.error === -1) {
            commit('setSnackbar', {
                type: 'success',
                msg: i18n.t('lang_GENERAL_SNACKBAR_COPY_SUCCESSFULL')
            })
            dispatch('fetchPricelists')
        } else {
            let errorMsg = response.response.errorMsg
            if(errorMsg !== undefined) {
                commit('setSnackbar', {
                    type: 'error',
                    msg: this._vm.$alvPlugin.isLangConst(errorMsg) ? i18n.t(errorMsg) : errorMsg
                })
            }
        }
    },

    // FETCH PRICELISTS ROWS
    async fetchPricelistsRows({ commit, getters }){
        let pricelistsRowsFromDB = await getters.getPricelistsDetails.rows
        if(pricelistsRowsFromDB === undefined) return null
        else {
            commit('setIsLoading', false)
            if(pricelistsRowsFromDB.length === 0) commit('setNoDataText', 'lang_GENERAL_MESSAGE_NO_RECORDS_FOUND')
            commit('setPricelistsPricelistsRows', pricelistsRowsFromDB)
        }
    },

    // DELETE Pricelists rows
    deleteSelectedPricelistsRows({ getters, commit }) {
        let id = getters.getSelectedPricelistsPricelistsRows[0] // only one id is passed
        let index = state.pricelistsPricelistsRows.findIndex(split => split.id == id)

        let numberOfRows = getters.getPricelistsPricelistsRows.length
        Vue.delete(state.pricelistsPricelistsRows, index)
        let newNumberOfRows = getters.getPricelistsPricelistsRows.length
        commit("setSelectedPricelistsPricelistsRows", [])

        if(numberOfRows > newNumberOfRows) {
            commit('setSnackbar', { 
                type: 'success', 
                msg: i18n.t('lang_GENERIC_SNACKBAR_DELETE_SUCCESSFUL') + '<br />' + i18n.t('lang_GENERAL_SNACKBAR_TEXT_CLICK_MAIN_SAVE_BUTTON'),
                timeout: -1
            })
        } else {
            commit('setSnackbar', { 
                type: 'error', 
                msg: i18n.t('lang_GENERIC_SNACKBAR_DELETE_NOT_SUCCESSFUL'),
            })
        }

        commit('setSelectedPricelistsPricelistsRows', [])
        if(newNumberOfRows === 0) commit('setNoDataText', 'lang_GENERAL_MESSAGE_NO_RECORDS_FOUND')
    },  
}

export default {
    state, getters, actions, mutations
}